import { useLanguageContext } from "../../../../context/LanguageContext";
import AxisConfigPage from "../../../../pages/integrations/axis_configs/axis_config/AxisConfigPage";
import { useAxisConfigEditRouteValidator } from "../../../validators/integrations/axis/AxisConfigEditRouteValidator";
import { RouteConfig } from "../../RouteConfig";
import useAxisConfigsRouteConfig from "./AxisConfigsRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useAxisConfigEditRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integrations/axis/:axis_config/edit")
    .setLabel(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.axis_config"),
        },
      ])
    )
    .setValidator(useAxisConfigEditRouteValidator())
    .setPage(<AxisConfigPage />)
    .setParent(useAxisConfigsRouteConfig());
}

export default useAxisConfigEditRouteConfig;